<template>
  <b-tab>
    <template v-slot:title>Withdraws</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Withdraws</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_withdraws == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_withdraws')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_withdraws')" />
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">Add New Withdraws</div>
          <div class="col-2">Approve Withdraws</div>
          <div class="col-2">Edit Withdraws</div>
          <div class="col-3">Delete Withdraws</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- New Savings -->
          <div class="col-2">
            <RockerSwitch v-if="item.new_withdraws == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_withdraws')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_withdraws')" />
          </div>

          <!-- Approve Savings -->
          <div class="col-2">
            <RockerSwitch v-if="item.approve_withdraws == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'approve_withdraws')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'approve_withdraws')" />
          </div>

          <!-- Edit Savings -->
          <div class="col-2">
            <RockerSwitch v-if="item.edit_withdraws == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'edit_withdraws')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'edit_withdraws')" />
          </div>

          <!-- Delete Savings -->
          <div class="col-2">
            <RockerSwitch v-if="item.delete_withdraws == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_withdraws')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_withdraws')" />
          </div>
        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "SharePermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_withdraws == 1);
    },
  },
  mounted() {
    // this.fetchPermissions();
    // this.isBusy = false;
  },
  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>